import React from 'react'
import { Button } from '@demandlocal/components'
import { ReactComponent as RoundedCheck } from './../../images/icons/rounded_check.svg'
import { ReactComponent as ChevronRight } from '../../images/icons/chevron_right.svg'

const PricingCardMobile = ({ feature }: any) => {
  return (
    <div className={'border-2 rounded-xl'}>
      <div className={'flex flex-col justify-center p-5'}>
        <div className={'flex flex-row items-end'}>
          <h2 className={'text-4xl font-bold text-primary-xiketic'}>{feature.title}</h2>
          {feature.locationBased && (
            <h4 className={'text-md text-primary-xiketic'}>/location</h4>
          )}
        </div>
        <div className={'flex flex-row gap-3 items-end mt-2 '}>
          <div className={'font-semibold'}>{feature.clientLinks}</div>
          {feature.locationBased && (
            <div className={'text-xs'}>1 inbound, 1 outbound</div>
          )}
        </div>
        <div className={'flex flex-col mt-4'}>
          <Button variant={'secondary'}>Contact Us</Button>
        </div>
      </div>
      <div className={'p-5 flex flex-col gap-2'}>
        {feature.features.map((f: any, index: number) => {
          return (
            <div key={index}>
              <div
                className={'flex flex-row gap-2 font-semibold pb-2 text-xs items-center'}>
                <div className={'bg-primary-persian-blue/10 rounded-full flex'}>
                  <ChevronRight className={'fill-primary-persian-blue'} />
                </div>
                {f.text}
              </div>
              {f.children?.length > 0 && (
                <div className={'flex flex-col text-sm pl-8 gap-2'}>
                  {f.children?.map((child: any, index: number) => {
                    return <span key={child}>{child}</span>
                  })}
                </div>
              )}
            </div>
          )
        })}
      </div>
      <div className={'flex flex-col justify-center p-5'}>
        <div className={'flex flex-col mt-4'}>
          <Button variant={'secondary'}>Contact Us</Button>
        </div>
      </div>
    </div>
  )
}

export default PricingCardMobile
